import React from 'react';

import { ConfirmModal } from '@metarouter-private/mr-mui';

import useIntegrationActivationModalProps from './useIntegrationActivationModalProps';

export default function IntegrationActivationModal() {
  const confirmModalProps = useIntegrationActivationModalProps();

  return <ConfirmModal {...confirmModalProps} />;
}
